import { useCallback } from 'react';
import { useI18n } from '@namespace/i18n';
import { useGetUserSegments } from '@namespace/segments';
import { gamesStoreActions } from '../../store';
import { useGetPlatformForFeed } from '../useGetPlatformForFeed';

const { PLEX_GET_CATEGORY_GAMES } = gamesStoreActions;

export const useGetLoadFeedCategoryCallback = (casinoType) => {
  const { language: lang } = useI18n();
  const { userSegmentsNames: userSegments } = useGetUserSegments();
  const platform = useGetPlatformForFeed();

  return useCallback(
    async ({ feedName, filter, id, isSetSingleFeedCategory }) => {
      return PLEX_GET_CATEGORY_GAMES({
        lang,
        feedName,
        platform,
        filter,
        userSegments,
        categoryId: id,
        casinoType,
        isSetSingleFeedCategory
      });
    },
    [lang, platform, userSegments, casinoType]
  );
};
